import styled from 'styled-components';
import media from 'styled-media-query';
import FilledButton from 'components/Buttons/FilledButton';
import { TableContainer } from 'components/DefaultTable/styles';
import colors from 'themes/Main';

const {
  gray01,
  gray03,
  warning,
  danger,
  pink,
  success,
  white,
  gray06,
  darkBlue,
} = colors;

export const Table = styled(TableContainer)`
  .table-responsive {
    padding-bottom: 150px;
  }

  * {
    cursor: default;
  }

  tbody tr {
    &:hover {
      background-color: transparent;
    }

    td {
      &:last-child {
        text-align: center;
      }

      &:nth-child(2) {
        width: 20vw;
      }
    }
  }

  thead tr th:nth-child(3),
  thead tr th:last-child {
    text-align: center;
  }

  .status- {
    color: ${gray01};
  }
  .status-refused {
    color: ${danger};
    text-decoration: underline;
    font-weight: 700;
  }

  .status-pending {
    color: ${pink};
    font-weight: 700;
  }

  .status-approved {
    color: ${success};
    font-weight: 700;
  }

  .status-analysing {
    color: ${warning};
    font-weight: 700;
  }

  .status-fatured {
    color: ${darkBlue};
    font-weight: 700;
  }
`;

export const Callback = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 64px;
`;

export const CallbackText = styled.h2`
  width: 500px;
  margin-top: 32px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: ${gray03};
  text-align: center;

  ${media.lessThan('medium')`
    width: 100vw;
    padding: 0 32px;
  `}
`;

export const TableCol = styled.td`
  cursor: default;
  position: relative;
  font-size: 14px;
  color: ${gray01};

  &.status-refused {
    position: relative;
    cursor: ${({ Text }) => (Text ? 'pointer' : 'default')};
    color: ${danger};
    text-decoration: underline;
    font-weight: 700;

    &:hover::before {
      content: ${({ Text }) => (Text ? `'Motivo: ${Text.toString()}'` : '')};
      z-index: 10;
      position: absolute;
      min-width: 280px;
      padding: 16px;
      top: 30px;
      right: 10%;
      background: ${white};
      color: ${gray01};
      font-size: 14px;
      font-weight: 500;
      box-shadow: 0px 3px 4px rgba(74, 74, 74, 0.12),
        0px 1px 5px rgba(74, 74, 74, 0.2), 0px 2px 4px rgba(74, 74, 74, 0.14);
    }
  }

  .status-pending {
    color: ${pink};
    font-weight: 700;
  }

  .status-approved {
    color: ${success};
    font-weight: 700;
  }
`;

export const ProjectMore = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover > div {
    display: block;
  }
`;

export const MoreActions = styled.div`
  z-index: 20;
  display: none;
  position: absolute;
  top: -30px;
  right: 10px;
  min-width: 180px;
  border-radius: 5px;
  box-shadow: 0px 4px 5px rgba(215, 220, 230, 0.2),
    0px 3px 14px rgba(215, 220, 230, 0.12),
    0px 8px 10px rgba(215, 220, 230, 0.14);
  background-color: ${white};
  transition: all 0.1s ease-out;
  margin-bottom: 0;
`;

export const MoreActionsHeader = styled.p`
  cursor: context-menu;
  text-align: left;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  color: ${gray03};
  padding: 16px 16px 0;
`;

export const MoreActionsItem = styled(FilledButton)`
  cursor: pointer;
  display: inline-block;
  width: 100%;
  padding: 10px 16px;
  border-top: 1px solid ${gray06};
  border-bottom: 1px solid ${gray06};
  color: ${gray01};
  font-size: 16px;
  transition: all 0.3s ease-in;
  text-decoration: none;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: ${white} !important;
  text-transform: initial;
  text-align: left;
  font-weight: 400;

  &:active,
  &:focus,
  &:hover {
    color: ${white};
    background: ${({ Type }) =>
      Type === 'danger' ? danger : darkBlue} !important;
    outline: none;
    appearance: none;
  }

  &:last-child {
    border-bottom: 0;
    margin-bottom: 16px;
  }
`;

export const MoreActionsTable = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 4px 12px;
  flex-wrap: wrap;
`;

export const MoreActionsTableHeader = styled.div`
  width: fill-available;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  padding: 4px 0;
  border-bottom: 1px solid ${gray06};

  div {
    color: ${gray01} !important;
    font-weight: 700;
    width: 90px;
    text-align: center;
    &:nth-child(1) {
      width: 120px;
      text-align: left;
    }
  }
`;

export const MoreActionsInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 4px 0;
  width: fill-available;
`;

export const MoreActionsIncoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MoreActionsIcon = styled.svg`
  width: 18px;
  height: 18px;
  margin-left: 8px;
`;

export const InfoStrong = styled.strong`
  color: ${darkBlue};
  font-weight: 700;
  width: 120px;
`;

export const InfoSpan = styled.span`
  color: ${gray01};
  font-weight: 400 !important;
  width: 90px;
  text-align: center;
`;
